/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type QrCodeCell_qrCode$ref = any;
type QrCodeList_lists$ref = any;
export type CreateQrCodeInput = {|
  clientMutationId?: ?string
|};
export type createQrCodeMutationVariables = {|
  input: CreateQrCodeInput
|};
export type createQrCodeMutationResponse = {|
  +createQrCode: ?{|
    +qrCodeEdge: ?{|
      +node: ?{|
        +$fragmentRefs: QrCodeCell_qrCode$ref
      |}
    |},
    +lists: ?{|
      +$fragmentRefs: QrCodeList_lists$ref
    |},
  |}
|};
export type createQrCodeMutation = {|
  variables: createQrCodeMutationVariables,
  response: createQrCodeMutationResponse,
|};
*/


/*
mutation createQrCodeMutation(
  $input: CreateQrCodeInput!
) {
  createQrCode(input: $input) {
    qrCodeEdge {
      node {
        ...QrCodeCell_qrCode
        id
      }
    }
    lists {
      ...QrCodeList_lists
      id
    }
  }
}

fragment QrCodeCell_qrCode on QrCode {
  id
  createdAt
  sign
}

fragment QrCodeList_lists on Lists {
  id
  qrCodes(first: 100) {
    edges {
      node {
        id
        ...QrCodeCell_qrCode
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateQrCodeInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sign",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQrCodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateQrCodePayload",
        "kind": "LinkedField",
        "name": "createQrCode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QrCodeEdge",
            "kind": "LinkedField",
            "name": "qrCodeEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QrCode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "QrCodeCell_qrCode"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "QrCodeList_lists"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQrCodeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateQrCodePayload",
        "kind": "LinkedField",
        "name": "createQrCode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QrCodeEdge",
            "kind": "LinkedField",
            "name": "qrCodeEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QrCode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "QrCodeConnection",
                "kind": "LinkedField",
                "name": "qrCodes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QrCodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QrCode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "qrCodes(first:100)"
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "QrCodeList_qrCodes",
                "kind": "LinkedHandle",
                "name": "qrCodes"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createQrCodeMutation",
    "operationKind": "mutation",
    "text": "mutation createQrCodeMutation(\n  $input: CreateQrCodeInput!\n) {\n  createQrCode(input: $input) {\n    qrCodeEdge {\n      node {\n        ...QrCodeCell_qrCode\n        id\n      }\n    }\n    lists {\n      ...QrCodeList_lists\n      id\n    }\n  }\n}\n\nfragment QrCodeCell_qrCode on QrCode {\n  id\n  createdAt\n  sign\n}\n\nfragment QrCodeList_lists on Lists {\n  id\n  qrCodes(first: 100) {\n    edges {\n      node {\n        id\n        ...QrCodeCell_qrCode\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9c764a49c86da2b3c04527c245d7b74e';

module.exports = node;
